import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var MaxPipe = (function () {
    function MaxPipe() {
    }
    MaxPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        if (input.length === 0) {
            return undefined;
        }
        var max = input[0];
        input.forEach(function (value) {
            if (max < value) {
                max = value;
            }
        });
        return max;
    };
    return MaxPipe;
}());
export { MaxPipe };
MaxPipe.decorators = [
    { type: Pipe, args: [{
                name: 'max'
            },] },
];
/** @nocollapse */
MaxPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=max.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/aggregate/max.pipe.js
// module id = 223
// module chunks = 103